module.exports = __webpack_public_path__ + "static/media/relay_logo_thumb_home.6efc2ae6.mp4";